export default __webpack_public_path__ + "static/media/ticker.84e7ae74.png";